//UserSessionInfo.js
import { ApiMsg } from "./AppConst";
import SessionUserVo from "./SessionUserVo";

export default class UserSessionInfo {
    sessionChecked = false;
    signedIn = false;

    //user = new SessionUserVo();

    constructor(sessionChecked) {
        this.sessionChecked = Boolean(sessionChecked);
        this.signedIn = false;
        this.user = new SessionUserVo();
    }

    static initFromUserObject = (userObj) => {
        const suvo = SessionUserVo.initFromObject(userObj);
        const sessionInfo = new UserSessionInfo(true);
        sessionInfo.user = suvo;
        sessionInfo.signedIn = suvo.sessionNote === ApiMsg.OK;
        return sessionInfo;
    };

    emptyUser = () => {
        this.user = new SessionUserVo();
    };

    isEtraceManager = () => this.user.isEtraceManager();
    isAdmin = () => this.user.isAdmin();

    hasHomeplusPower = () => this.user.hasHomeplusPower();

    isHomeplusUser = () => this.user.isHomeplusUser();

    isHomeplusOrEtrace = () => this.user.isHomeplusOrEtrace();

    isStoreUser = () => this.user.isStoreUser();

    isTransCompanyUser = () => this.user.isTransCompanyUser();

    isDriver = () => this.user.isDriver();

    hasRealUserLoggedIn = () => this.user.hasRealUserLoggedIn();

    isSessionAdminAsUser = () => this.user.isSessionAdminAsUser();

    getDcCd = () => {
        return this.user.getDcCd();
    };
    
    // dcList: dcInfoListRepoData.records = [{dcCd, dcTypeCd,...}]
    getDcTypeCode = (dcList) => {
        let dcCd = this.user.getDcCd();

        if(dcCd) {
            for(const dc of dcList) {
                if(dc.dcCd === dcCd) {
                    return dc.dcTypeCd;
                }
            }
        }
        return null;
    };

    /**
     * 주어진 프로세스에 대한 실행 권한이 있는지 확인한다.
     * @param {object} authNode a node of authTableTreeRepo. tre[procName]
     */
    checkAuth = (authNode) => {
        if(authNode && authNode.allow) {
            return authNode.allow.includes(this.user.authClassInt);
        }
        return false;
    };

    ifLocal = (callback) => {
        let isLocal = window.location.href.includes('//localhost');
        /* if(!isLocal) {
            isLocal = this.user.classNo <= UserClass.EtraceStaff.classNo;
        } */
        if(isLocal) callback(this);
    };

    isExpressUser = (dcInfoList) => {
        const dcTypeCd = this.getDcTypeCode(dcInfoList);
        return dcTypeCd === 'E';
    };

    isFreshUser = (dcInfoList) => {
        const dcTypeCd = this.getDcTypeCode(dcInfoList);
        return dcTypeCd === 'F';
    };
}
